// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bigbutton":"BigButton__bigbutton--1sFnq"};